import React, { Component } from 'react';
import { Card, Col, Row, Tabs } from 'antd';
import moment from 'moment';

import { queryOrderInfo } from '@api/xxcrm/order';
import base from '@util/base';

import { BackBtn } from '@comm/BackBtn';
import '@comm/btn.less'; // 4.空间
import Description from './Description';
import Pro400 from './Pro400'; // 6+8.400电话
import ProAd from './ProAd'; // 15.广告下单
import ProCRM from './ProCRM'; // 12.爱上班+13.爱客-CRM+14.爱客-钉钉
import ProDomain from './ProDomain'; // 3.域名
import ProEmail from './ProEmail'; // 5.邮箱
import ProFans from './ProFans'; // 16.微信吸粉
import ProMom from './ProMom'; // 18.妈妈去哪儿
import ProQqNew2 from './ProQqNew2'; // 1.2月企业QQ新开
import ProQqNew5 from './ProQqNew5'; // 7.5月企业QQ新开
import ProQqSequel from './ProQqSequel'; // 2.企业QQ续费
import ProWxWebsite from './ProWxWebsite'; // 9.网站+10.微信网站（微客来）+11.微信网站（赢客来
import ProYoudao from './ProYoudao'; // 17.有道云
import ProZone from './ProZone';

const { TabPane } = Tabs;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const uuid = this.props.params.orderUuid;
    this.loadOrderDetail(uuid);
  }

  callback = () => {};

  /**
   * 获取订单详情
   */
  loadOrderDetail = uuid => {
    queryOrderInfo(uuid).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
        });
      }
    });
  };

  goBack = () => {
    this.props.router.go(-1);
  };

  /**
   * 发票类型
   */
  judgeInvoiceType = type => {
    let invoiceType = '';
    if (type === '1') {
      invoiceType = '国税网络在线发票';
    } else if (type === '2') {
      invoiceType = '增值税专用发票';
    } else if (type === '3') {
      invoiceType = '增值税普通发票';
    }
    return invoiceType;
  };

  /**
   * 申请类型
   */
  judgeSubmitType = type => {
    let submitType = '';
    if (type === '1') {
      submitType = '提前开票';
    } else if (type === '2') {
      submitType = '到账开票';
    }
    return submitType;
  };

  /**
   * 判断开户银行
   */
  judgeBank = id => {
    let bank = '';
    base.bank.map(item => {
      if (item.key === id) {
        bank = item.name;
        return bank;
      }
      return item;
    });
    return bank;
  };

  render() {
    const { data } = this.state;
    return (
      <div className="description">
        <Row justify="start" type="flex" style={{ marginBottom: '16px' }}>
          <BackBtn />
        </Row>
        <Card title="基本信息">
          <Row>
            <Description term="签单名称" col={24}>
              <span>
                <span>{data.orderName || ''}</span>
                <span>{data.orderNo ? `(${data.orderNo})` : ''}</span>
                <span>{data.orderObject ? `[${data.orderObject}]` : ''}</span>
              </span>
            </Description>
          </Row>
          <Row>
            <Description term="打款名称">{data.recieveName}</Description>
            <Description term="签单日期">
              {data.createTime ? moment.unix(data.createTime / 1000).format('YYYY-MM-DD') : ''}
            </Description>
            <Description term="合同号">{data.contractNo}</Description>
          </Row>
          <Row>
            <Description term="签单销售">{data.cusrName}</Description>
            <Description term="营业执照图">
              {data.companyPic ? <a href={data.companyPic}>查看</a> : ''}
            </Description>
            <Description term="合同附件">
              {data.contractPic ? <a href={data.contractPic}>查看</a> : ''}
            </Description>
          </Row>
          <Row>
            <Col span={24}>
              <Row type="flex">
                <Col style={{ width: '90px' }}>
                  <span className="title">签单备注信息：</span>
                </Col>
                <Col style={{ width: '80%' }}>
                  <span dangerouslySetInnerHTML={{ __html: data.orderRemark }} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
        <Card title="签单费用明细">
          <Row>
            <Description term="主要费用">{data.mainPrice}</Description>
            <Description term="购买年限">{data.years}</Description>
            <Description term="参加活动">不参加活动</Description>
          </Row>
          <Row>
            <Description term="汇款底单">
              {data.payPic ? <a href={data.payPic}>查看</a> : ''}
            </Description>
            <Description term="费用总计">{data.totalPrice}</Description>
            <Description term="已收款">{data.recievedPrice}</Description>
          </Row>
        </Card>
        {data.projectType === 1 ? <ProQqNew2 proinfo={data.project} title="2月企业QQ新开" /> : ''}
        {data.projectType === 2 ? <ProQqSequel proinfo={data.project} title="企业QQ续费" /> : ''}
        {data.projectType === 3 ? <ProDomain proinfo={data.project} title="域名" /> : ''}
        {data.projectType === 4 ? <ProZone proinfo={data.project} title="空间" /> : ''}
        {data.projectType === 5 ? <ProEmail proinfo={data.project} title="邮箱" /> : ''}
        {data.projectType === 6 || data.projectType === 8 ? (
          <Pro400 proinfo={data.project} title="电话400" />
        ) : (
          ''
        )}
        {data.projectType === 7 ? <ProQqNew5 proinfo={data.project} title="5月企业QQ新开" /> : ''}
        {data.projectType === 9 ? <ProWxWebsite proinfo={data.project} title="网站" /> : ''}
        {data.projectType === 10 ? (
          <ProWxWebsite proinfo={data.project} title="微信网站（微客来）" />
        ) : (
          ''
        )}
        {data.projectType === 11 ? (
          <ProWxWebsite proinfo={data.project} title="微信网站（赢客来）" />
        ) : (
          ''
        )}
        {data.projectType === 12 ? <ProCRM proinfo={data.project} title="爱上班" /> : ''}
        {data.projectType === 13 ? <ProCRM proinfo={data.project} title="爱客-CRM" /> : ''}
        {data.projectType === 14 ? <ProCRM proinfo={data.project} title="爱客-钉钉" /> : ''}
        {data.projectType === 15 ? <ProAd proinfo={data.project} title="广告下单" /> : ''}
        {data.projectType === 16 ? <ProFans proinfo={data.project} title="微信吸粉" /> : ''}
        {data.projectType === 17 ? <ProYoudao proinfo={data.project} title="有道云" /> : ''}
        {data.projectType === 18 ? <ProMom proinfo={data.project} title="妈妈去哪儿" /> : ''}

        {data.invoices && data.invoices.length > 0 ? (
          <Card title="开票信息" className="invoices">
            <Tabs onChange={this.callback}>
              {data.invoices.map((item, index) => {
                return (
                  <TabPane tab={`发票${index + 1}`} key={item.uuid}>
                    <Row gutter={25}>
                      <Col span={11} offset={1}>
                        <Description term="已开发票" col={24}>
                          {item.no}
                        </Description>
                        <Description term="申请类型" col={24}>
                          {() => this.judgeSubmitType(item.submitType)}
                        </Description>
                        <Description term="发票抬头" col={24}>
                          {item.invoiceTop}
                        </Description>
                        <Description term="发票类型" col={24}>
                          {() => this.judgeInvoiceType(item.invoiceType)}
                        </Description>
                        <Description term="金额" col={24}>
                          {item.price}
                        </Description>
                        <Description term="开户银行" col={24}>
                          {() => this.judgeBank(item.bank)}
                        </Description>
                        <Description term="注册电话" col={24}>
                          {item.mobile}
                        </Description>
                      </Col>
                      <Col span={11}>
                        <Description term="开票公司" col={24}>
                          {item.companyName}
                        </Description>
                        <Description term="开票人" col={24}>
                          {item.cusrName}
                        </Description>
                        <Description term="企业税号" col={24}>
                          {item.taxId}
                        </Description>
                        <Description term="税务登记证副本" col={24}>
                          {item.taxCert ? <a href={item.taxCert}>查看</a> : ''}
                        </Description>
                        <Description term="银行账户" col={24}>
                          {item.account}
                        </Description>
                        <Description term="注册地址" col={24}>
                          {item.regAddr}
                        </Description>
                        <Description term="备注" col={24}>
                          {item.remark}
                        </Description>
                      </Col>
                    </Row>
                  </TabPane>
                );
              })}
            </Tabs>
          </Card>
        ) : (
          ''
        )}
        <Card title="联系人信息">
          <Row>
            <Description term="联系人">{data.contactName}</Description>
            <Description term="职位">{data.contactPosition}</Description>
            <Description term="座机">{data.contactPhone}</Description>
          </Row>
          <Row>
            <Description term="E-mail">{data.contactEmail}</Description>
            <Description term="手机号">{data.contactMobile}</Description>
            <Description term="QQ">{data.contactQq}</Description>
          </Row>
        </Card>
        <Card title="企业负责人信息">
          <Row>
            <Description term="联系人">{data.principalName}</Description>
            <Description term="职位">{data.principalPosition}</Description>
            <Description term="座机">{data.principalPhone}</Description>
          </Row>
          <Row>
            <Description term="E-mail">{data.principalEmail}</Description>
            <Description term="手机号">{data.principalPhone}</Description>
            <Description term="QQ">{data.principalQq}</Description>
          </Row>
        </Card>
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/xianxing/order/PageDetail.js